import React, { useState } from 'react';
import lunchData from './lunchTime';

const Ruokailu = () => {
  const [activeTab, setActiveTab] = useState('Lauantai 17.05.2025');

  const paragraphStyle = {
    color: 'white',
    lineHeight: '2',
    fontSize: '18px',
    textAlign: 'center',
  };

  const dayContainerStyle = {
    border: '2px double #F0AE2E',
    marginBottom: '20px',
    padding: '10px',
  };

  const tabs = lunchData.map(day => day.day);

  const activeData = lunchData.find(day => day.day === activeTab);

  return (
    <div>
      {/* Slider tabs */}
      <p style={paragraphStyle}>
        Joukkueita pyydetään noudattamaan alla olevaa ruokailuaikataulua.
      </p>
      <div className="tab-container">
        <div
          className="highlight-slider"
          style={{
            transform:
              activeTab === tabs[0]
                ? 'translateX(0%)'
                : 'translateX(100%)',
          }}
        />
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`U8-lohko-tab-button ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.includes('Lauantai') ? 'Lauantai' : 'Sunnuntai'}
          </button>
        ))}
      </div>

      

      <div style={dayContainerStyle}>
        <h3>{activeData.day}</h3>
        {activeData.locations.map((location, locationIndex) => (
          <div key={locationIndex}>
            <h4>{location.location}</h4>
            <table className="ranking-table">
              <thead>
                <tr>
                  <th>Aika</th>
                  <th style={{ textAlign: 'left', paddingLeft:'10px'}}>Joukkue</th>
                </tr>
              </thead>
              <tbody>
                {location.lunchTimes.map((time, timeIndex) => (
                  <tr key={timeIndex}>
                    <td style={{ textAlign: 'left',  paddingLeft:'10px' }} >{time.time}</td>
                    <td style={{ textAlign: 'left', display: 'flex', alignItems: 'center', gap: '8px', paddingLeft:'10px' }}>
  {time.logoUrl && (
    <img
      src={time.logoUrl}
      alt={time.team}
      style={{ width: '30px', height: '30px', objectFit: 'contain' }}
    />
  )}
  {time.team}
</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ruokailu;
